// File change directive for CSV import
export default function fileChangeDirective() {
    return {
        restrict: 'A',
        scope: {
            fileChange: '&'
        },
        link: function(scope, element) {
            element.on('change', function(event) {
                scope.fileChange({ $event: event });
                scope.$apply();
            });
        }
    };
} 